import Link from "next/link";
import Image from "next/image";

interface ArticleCardProps {
  article: {
    id: string;
    url: string;
    title: string;
    description: string;
    image_url: string;
    created_at: string;
  };
  locale: string;
  isLarge?: boolean;
  className?: string;
}

export function ArticleCard({
  article,
  locale,
  isLarge = false,
  className = "",
}: ArticleCardProps) {
  return (
    <article className={`transition-shadow ${className}`}>
      <Link href={`/${locale}/blog/${article.url}`}>
        <div className="relative aspect-[21/9] rounded-2xl overflow-hidden">
          <Image
            src={article.image_url}
            alt={article.title}
            fill
            className="object-cover"
            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, (max-width: 1536px) 33vw"
          />
        </div>
        <div className="pt-4">
          <h2 className="text-xl sm:text-2xl font-semibold mb-2 sm:mb-3">
            {article.title}
          </h2>
          <p
            className={`text-gray-400 text-sm sm:text-base ${
              isLarge ? "line-clamp-1" : "line-clamp-2"
            }`}
          >
            {article.description}
          </p>
          <div className="mt-3 sm:mt-4 text-sm text-gray-400">
            {new Date(article.created_at).toLocaleDateString(locale, {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })}
          </div>
        </div>
      </Link>
    </article>
  );
}
